import { render, staticRenderFns } from "./InputFormMailInquiry.vue?vue&type=template&id=fe2c5dc6&"
import script from "./InputFormMailInquiry.vue?vue&type=script&lang=ts&"
export * from "./InputFormMailInquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports